<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_iv"></a><a id="copyright"></a>© 2007 The Johns Hopkins University Press</p>
<p class="copyright">All rights reserved. Published 2007</p>
<p class="copyright">Printed in the United States of America on acid-free paper</p>
<p class="copyright1">Johns Hopkins Paperback edition, 2010</p>
<p class="copyright">2  4   6  8  9  7  5  3  i</p>
<p class="copyright1">The Johns Hopkins University Press</p>
<p class="copyright">2715 North Charles Street</p>
<p class="copyright">Baltimore, Maryland 21218–4363</p>
<p class="copyright">www.press.jhu.edu</p>
<p class="copyright1"><em>The Library of Congress has catalogued the hardcover edition of this book asfollows:</em></p>
<p class="copyright1">Ruggiero, Guido, 1944—</p>
<p class="copyright">Machiavelli in love : sex, self, and society in the Italian Renaissance / Guido Ruggiero.</p>
<p class="copyright">p. cm.</p>
<p class="copyright">Includes bibliographical references and index.</p>
<p class="copyright">ISBN-13: 978-0-8018-8516-7 (hardcover : alk. paper)</p>
<p class="copyright">ISBN-10: 0-8018-8516-7 (hardcover : alk. paper)</p>
<p class="copyright">1 . Sex customs—Italy—History. 2. Renaissance—Italy.</p>
<p class="copyright">3 . Sex—Social aspects—Italy—History. 4. Sex role—Italy—History.</p>
<p class="copyright">5 . Sex in literature. I. Title.</p>
<p class="copyright">HQ18.I8I834 2006</p>
<p class="copyright">306.70945 09024—dc22</p>
<p class="copyright">2006015555</p>
<p class="copyright1">A catalog record for this book is available from the British Library.</p>
<p class="copyright1">ISBN 13: 978-0-8018-9835-8</p>
<p class="copyright">ISBN 10: 0-8018-9835-8</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?546ab307